import React from 'react';
import { apps } from '../config/apps';
import titleImg from '../assets/title.png';

const HomePage: React.FC = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={titleImg} className="Title" alt="Monogatari" />
        <p className="ProjectTagline">Building a place for your people</p>
        <div className="AppGrid">
          {apps.map((app) => (
            <article key={app.id} className="AppCard" style={{ '--accent': app.accentColor || '#666' } as React.CSSProperties}>
              <div className="AppCard-icon" style={{ backgroundColor: app.accentColor || '#666' }}>
                {app.icon ? (
                  <img src={app.icon} alt="" className="AppCard-iconImg" />
                ) : (
                  <span className="AppCard-initial">{app.name.charAt(0)}</span>
                )}
              </div>
              <div className="AppCard-content">
                <h2 className="AppName">{app.name}</h2>
                {app.tagline && <p className="AppTagline">{app.tagline}</p>}
                {app.description && <p className="AppDescription">{app.description}</p>}
                <div className="AppStoreLinks">
                  {app.storeLinks.apple && (
                    <a href={app.storeLinks.apple} target="_blank" rel="noopener noreferrer" className="store-link">
                      <span className="store-badge store-badge-apple">App Store</span>
                    </a>
                  )}
                  <a href={app.storeLinks.google} target="_blank" rel="noopener noreferrer" className="store-link">
                    <span className="store-badge store-badge-google">Google Play</span>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </header>
    </div>
  );
};

export default HomePage;
